"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoveNextPlayerRule = void 0;
const game_rule_1 = require("./game-rule");
const auto_player_deal_command_1 = require("../commands/auto-commands/auto-player-deal-command");
class MoveNextPlayerRule extends game_rule_1.AbstractGameRule {
    constructor(playerId) {
        super();
        this.playerId = playerId;
    }
    applyRule(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            context.playerManager.setCurrentPlayerComplete(instant);
            context.playerManager.moveToNextPlayer(this.playerId, instant);
            yield this.dealPlayerCard(commandHash, existingDeal, instant, context);
            return false;
        });
    }
    dealPlayerCard(commandHash, existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            const autoPlayerDealCommand = new auto_player_deal_command_1.AutoPlayerDealCommand();
            yield autoPlayerDealCommand.executeCommand(commandHash, existingDeal, instant, context);
        });
    }
}
exports.MoveNextPlayerRule = MoveNextPlayerRule;
